import styled from "styled-components";

export const CheckoutWrapper = styled.div``;

export const StickyWrapper = styled.div`
  position: sticky;
  top: 75px;

  .loading {
    position: absolute;
    background-color: #fff;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 90;
  }

  @media (max-width: 991px) {
    position: relative;
    top: 0px;
    margin: 50px 0px;
  }
`;

// main의 큰 제목
export const MainMenuTitle = styled.div`
  margin-bottom: 1.5rem !important;
  display: flex;
  justify-content: space-between;
  & span {
    cursor: pointer;
    color: #253d4e;
    border: 1px solid #ececec;
    background-color: #fff;
    padding: 5px 10px;
    border-radius: 5px;
    transition: all 0.1s ease 0s;
    :hover {
      color: #3bb77e;
      border-color: #3bb77e;
    }
  }
`;

// form의 내부 각 부분들
export const FormInputWrapper = styled.div`
  width: 100%;
  margin-bottom: 2rem !important;
`;

// form 내부 div -row
export const FormInputRow = styled.div`
  width: 100%;
  display: flex;
  display: -webkit-flex;
  display: -ms-flexbox;
  margin-bottom: 1rem;
  align-items: center;

  @media (max-width: 460px) {
    flex-wrap: wrap;
  }
`;

// span
export const FormInputBasicSpan = styled.span`
  width: 15% !important;
  min-width: 70px !important;
  font-size: 16px;
  word-break: keep-all;
`;

// input
export const FormInputBasicInput = styled.input`
  /* background: #fff; */
  border: 1px solid #ececec;
  height: 40px;
  -webkit-box-shadow: none;
  box-shadow: none;
  padding-left: 20px;
  font-size: 16px;
  width: 100%;
  margin-right: 1rem;

  ::placeholder {
    color: #969696;
    font-size: 14px;
  }

  :nth-of-type(2) {
    display: ${(props) => (props.emailLast ? "block" : "none")};
  }

  :last-child {
    margin: 0;
  }

  :focus {
    background: transparent;
    border-color: #bce3c9;
  }
  @media (max-width: 460px) {
    width: 70%;
    :nth-of-type(2) {
      width: 75%;
      margin-left: 0;
    }
  }
`;

// select
export const FormInputBasicSelect = styled.select`
  width: 50% !important;
  height: 40px;
  border-radius: 10px;
  border: 1px solid #ececec;
  margin-right: 10px;

  @media (max-width: 460px) {
    width: 70%;
  }
`;

export const FormBasicBtn = styled.button`
  width: 20%;
  height: 40px;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  padding: 0;
  color: #fff;
  word-break: keep-all;
  border: 1px solid transparent;
  background-color: ${(props) =>
    props.isCheckingTime ? "#ececec" : "#3bb77e"};
  cursor: pointer;
  border-radius: 10px;
  line-height: 1.4;
  :hover {
    background: #fdc040 !important;
  }
  @media (max-width: 460px) {
    width: 30%;
    font-size: 12px;
  }
`;

// 핸드폰 인증
export const CheckoutPhoneInfo = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 1rem;
  align-items: center;

  & > li {
    list-style: none;
    font-size: 16px;
    margin-left: 1rem;
  }

  & > input {
    background: #fff;
    border: 1px solid #ececec;
    height: 40px;
    -webkit-box-shadow: none;
    box-shadow: none;
    padding-left: 20px;
    font-size: 16px;
    width: 50%;
    min-width: 90px;
    margin-right: 1rem;

    ::placeholder {
      color: #dbdbdb;
      font-size: 13px;
    }

    :last-child {
      margin: 0;
    }
    :focus {
      background: transparent;
      border-color: #bce3c9;
    }
    @media (max-width: 460px) {
      width: 43%;
    }
  }

  & > button {
    @media (max-width: 460px) {
      width: 23%;
    }
  }

  & > select {
    width: 10%;
    min-width: 50px;
    height: 40px;
    padding-left: 10px;
    border-radius: 10px;
    border: 1px solid #ececec;
    margin-right: 1rem;
  }
`;

// 주소 검색
export const AddressSearch = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 1rem;
  align-items: center;

  & input {
    height: 40px;
    width: calc(30% - 10px);
    min-width: 65px;
    margin-left: 10px;
    text-align: center;
    padding: 0;
  }

  @media (max-width: 460px) {
    flex-wrap: wrap;
    & input {
      width: 37.5%;
    }
  }
`;

// 주문 상품 목록
export const CheckoutProductsWrapper = styled.div`
  width: 100%;

  & td {
    width: 15%;
    word-break: keep-all;
    padding-bottom: 1rem;

    & img {
      cursor: pointer;
    }

    :nth-of-type(2) {
      width: 30%;
      h6 {
        cursor: pointer;
      }
    }

    :last-of-type {
      width: 3%;
    }
  }
  @media (max-width: 460px) {
    display: none;
  }
`;

// 모바일 상품 목록
export const CheckoutProductsMobile = styled.div`
  display: flex;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ececec;
  & i {
    cursor: pointer;
    :hover {
      color: #3bb77e;
    }
  }

  @media (max-width: 460px) {
    width: 100%;
    display: flex;
    margin-top: 1rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #ececec;
    font-size: 14px;
  }
`;

export const ProductMobileImg = styled.div`
  width: 20%;
  margin-right: 5%;
  & img {
    width: 100%;
  }
`;

export const ProductMobileInfo = styled.div`
  width: 75%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  font-size: 1rem;
  & h6 {
    cursor: pointer;
    width: fit-content;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-bottom: 5px;
    font-size: 20px;
    :hover {
      color: #3bb77e;
    }
  }
  & > span {
    margin-bottom: 10px;
    font-size: 16px;
  }
  & div {
    display: flex;
    align-items: center;
    justify-content: space-between;

    & span {
      font-size: 18px;
    }

    & h6 {
      margin-bottom: 0;
      font-size: 18px;
      border-right: 1px solid gray;
      padding-right: 10px;
    }

    & i {
      font-size: 16px;
      margin-left: 10px;
      margin-right: 10px;
      :nth-of-type(2) {
        margin-left: 10px;
      }
    }
  }
  @media (max-width: 575px) {
    & h6 {
      font-size: 18px;
    }
    & > span {
      font-size: 16px;
    }
    & div {
      & h6 {
        font-size: 16px;
      }
    }
  }
  @media (max-width: 424px) {
    & h6 {
      font-size: 16px;
    }
    & > span {
      font-size: 14px;
    }
  }
`;

// 결제 수단
export const PaymentMethodWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 0px;

  & input {
    display: none;
  }
`;

export const PaymentMethodOption = styled.label`
  width: 100%;
  min-height: 100px;
  word-break: keep-all;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: ${(props) =>
    props.checked ? "2px solid #3bb77e" : "1px solid #ececec"};
  border-right: ${(props) =>
    props.checked ? "2px solid #3bb77e" : "1px solid #fff"};
  :last-of-type {
    border-right: ${(props) =>
      props.checked ? "2px solid #3bb77e" : "1px solid #ececec"};
  }
  background-color: ${(props) => (props.checked ? "#deffe661" : "#fff")};
  color: #343a40;
  cursor: pointer;

  & i {
    font-size: 35px;
    @media (max-width: 460px) {
      font-size: 30px;
    }
  }

  & span {
    display: flex;
    align-items: center;
    width: 100%;
    font-size: 13px;
    font-weight: 500;
    word-break: keep-all;
    text-align: center;
    line-height: 1;
    @media (max-width: 460px) {
      font-size: 12px;
      line-height: 1.5;
    }
  }

  .kakaopay {
    width: 60px;
    height: 25px;
    @media (max-width: 460px) {
      width: 40px;
      height: 16.5px;
    }
  }

  .methodImg {
    width: 7rem;
    height: 4.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 460px) {
      width: 100%;
      height: 40%;
    }
  }

  .methodName {
    width: 7rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    @media (max-width: 460px) {
      align-items: center;
    }
  }

  .naverpay {
    width: 45px;
    height: 45px;
    @media (max-width: 460px) {
      width: 30px;
      height: 30px;
    }
  }
  & img {
    width: 35px;
    height: 35px;
    @media (max-width: 460px) {
      width: 25px;
      height: 25px;
    }
  }
`;

export const CashMethodOption = styled.div`
  margin-top: 1rem;

  @media (max-width: 460px) {
    width: 100% !important;
  }
  & select {
    width: 25%;
    text-align: center;
    @media (max-width: 460px) {
      width: 30% !important;
      font-size: 0.8rem;
    }
  }
  & input {
    width: 70%;
    color: black;
    @media (max-width: 460px) {
      width: 60%;
    }
  }
  .company-title {
    display: flex;
    flex-direction: column;
    & div {
      font-size: 1rem;
      display: flex;
      align-items: center;
      span {
        color: #198754;
        margin-left: 5px;
      }
      a {
        margin-left: 5px;
      }
      @media (max-width: 460px) {
        word-break: keep-all;
        flex-wrap: wrap;
      }
    }
  }

  .payment_option {
    width: 100%;
    display: flex;
  }
`;

// 결제 금액 부분
export const PayPriceWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 3rem;
`;

export const PayPriceRow = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  font-size: 1rem;
  margin-bottom: 0.7rem;
  :last-of-type {
    margin: 0;
  }

  & span {
    :first-of-type {
      width: 40%;
    }
    :last-of-type {
      width: 60%;
      border-bottom: 1px solid #ececec;
      text-align: end;
      margin-right: 5px;
    }
  }

  .usePoint {
    width: 100%;
    height: 1.5rem;
    font-size: 1rem;
    margin-right: 10px;
    text-align: end;
    padding: 0;
    color: #7e7e7e;
    border: none;
    border-radius: 0px;
    :focus {
      border: 1px solid #3bb77e;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    margin: 0;
  }

  .couponSelect {
    width: 13rem;
  }

  & select {
    text-align: center;
    border: 1px solid #ececec;
    border-radius: 10px;
    padding: 5px 15px;
    font-size: 0.9rem;
  }
`;

export const TotalPrice = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #ececec;
  & span {
    font-size: 1.5rem;
    font-weight: 700;
    color: #3bb77e;
  }
  @media (max-width: 460px) {
    & h4 {
      font-size: 22px;
    }
    & span {
      font-size: 22px;
    }
  }
`;

export const PayPolicyWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 1rem;

  .form-check-label::before {
    margin: 0px 8px 2px 0;
  }

  .policy {
    display: flex;
    justify-content: space-between;
    & span {
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }
`;

export const PayConfirmBtn = styled.button`
  width: 100%;
  margin-top: 1.7rem;
`;

export const PointInfo = styled.div`
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  & span {
    display: flex;
    align-items: center;
    .sticker {
      margin-right: 0px;
    }
  }
`;
